import {AutomaticInteractionStatus} from 'src/domain/enums/automatic-interaction.status';
import {translate} from 'src/i18n';
import {MERCHANT_PERMISSIONS} from './permissions.generated';

const API_ENDPOINTS_HOST = {
  REACT_APP_API_MASTER_DATA: 'REACT_APP_API_MASTER_DATA',
  REACT_APP_API_ADMIN_AUTH: 'REACT_APP_API_ADMIN_AUTH',
  REACT_APP_API_AUTH: 'REACT_APP_API_AUTH',
  REACT_APP_API_CMS: 'REACT_APP_API_CMS',
  REACT_APP_API_CDP: 'REACT_APP_API_CDP',
  REACT_APP_API_GAME: 'REACT_APP_API_GAME',
  REACT_APP_IDENTITY_ADDRESS: 'REACT_APP_IDENTITY_ADDRESS',
  REACT_APP_API_TRANSACTION: 'REACT_APP_API_TRANSACTION',
  REACT_APP_API_CRM: 'REACT_APP_API_CRM',
  REACT_APP_API_DOCUMENT: 'REACT_APP_API_DOCUMENT',
  REACT_APP_API_GIFT: 'REACT_APP_API_GIFT',
  REACT_APP_API_ADS: 'REACT_APP_API_ADS',
  REACT_APP_API_ACTIVITY: 'REACT_APP_API_ACTIVITY',
  REACT_APP_API_REPORT: 'REACT_APP_API_REPORT',
  REACT_APP_API_CAMPAIGN: 'REACT_APP_API_CAMPAIGN',
};

const API_METHOD = {
  POST: 'POST',
  GET: 'GET',
  PUT: 'PUT',
  DELETE: 'DELETE',
};

const STORAGE_KEY = {
  ACCESS_TOKEN: 'ACCESS_TOKEN',
  MERCHANT_ID: 'MERCHANT_ID',
  USER_INFO_DATA: 'USER_INFO_DATA',
};

const STORE_TYPE = {
  ONLINE: 'ONLINE',
  OFFLINE: 'OFFLINE',
};

const CLASSIFIED_GIFT = [
  {
    get label() {
      return translate('constants:qua_de_chill');
    },
    value: 'CHILL_GIFT',
  },
  {label: 'E-voucher', value: 'E_VOUCHER'},
  {
    get label() {
      return translate('constants:qua_cua_hang');
    },
    value: 'STORE_GIFT',
  },
];

const DELIVERY_TRANSACTION_PICKUP_TYPE = [
  {
    get label() {
      return translate('constants:thu_gom_tan_noi');
    },
    value: 1,
  },
  {
    get label() {
      return translate('constants:gui_hang_tai_buu_cuc');
    },
    value: 2,
  },
];

const DELIVERY_TRANSACTION_SERVICE_NAME = [
  {
    get label() {
      return translate('constants:chuyen_phat_nhanh');
    },
    value: 'EMS',
  },
  {
    get label() {
      return translate('constants:chuyen_phat_thuong');
    },
    value: 'BK',
  },
  {
    get label() {
      return translate('constants:dich_vu_thoa_thuan_rieng_giua');
    },
    value: 'DONG_GIA',
  },
  {
    get label() {
      return translate('constants:tmdt_chuyen_phat_nhanh_ems');
    },
    value: 'TMDT_EMS',
  },
  {
    get label() {
      return translate('constants:tmdt_chuyen_phat_tieu_chuan');
    },
    value: 'TMDT_BK',
  },
  {
    get label() {
      return translate('constants:tmdt_chuyen_phat_nhanh_ems_tiet');
    },
    value: 'TMDT_EMS_TK',
  },
];

const MERCHANT_NAME_OF_STRONGBOW = 'strongbow';
const STATUS_COLOR = (status) => {
  let name = '';
  switch (status) {
    case 'GIFT_REJECTED':
    case 'CONTENT_REJECTED':
    case 'CONTENT_SETTING_REJECTED':
    case 'NOTI_SETTING_REJECTED':
    case 'NOTI_GIFT_REJECTED':
    case 'CANCELED_TICKET':
      name = 'bg-danger';
      break;
    case 'GIFT_PENDING':
    case 'CONTENT_PENDING':
    case 'CONTENT_SETTING_PENDING':
    case 'NOTI_SETTING_PENDING':
    case 'GIFT_PENDING_REMOVED_ON_APP':
    case 'CONTENT_PENDING_REMOVED_ON_APP':
    case 'CONTENT_SETTING_PENDING_REMOVED_ON_APP':
    case 'NOTI_SETTING_PENDING_REMOVED_ON_APP':
    case 'GAME_SETTING_PENDING_REMOVE_ON_APP':
    case 'CONTENT_SETTING_PENDING_REMOVE_ON_APP':
    case 'CONTENT_PENDING_REMOVE_ON_APP':
    case 'NOTI_GIFT_PENDING':
    case 'NEW_TICKET':
    case 'RE_OPEN_TICKET':
    case 'WAITING_FOR_RESPONSE':
    case 'PENDING_TICKET':
    case 'RECEIVED_TICKET':
    case 'NEW_TICKET_MESSAGE':
      name = 'bg-warning';
      break;
    case 'GIFT_APPROVED':
    case 'CONTENT_APPROVED':
    case 'CONTENT_SETTING_APPROVED':
    case 'NOTI_SETTING_APPROVED':
    case 'NOTI_GIFT_APPROVED':
    case 'COMPLETED':
      name = 'bg-success';
      break;
    case 'NOTI_SETTING_REMOVED_ON_APP':
    case 'GIFT_REMOVED_ON_APP':
    case 'CONTENT_REMOVED_ON_APP':
    case 'CONTENT_SETTING_REMOVED_ON_APP':
      name = 'bg-remove-on-ap';
      break;
    default:
      name = 'bg-success';
      break;
  }
  return name;
};
const PROCESSING_STATUS = [
  {
    id: 'GIFT_PENDING',
    get label() {
      return translate('constants:cho_duyet');
    },
  },
  {
    id: 'GIFT_APPROVED',
    get label() {
      return translate('constants:da_duyet');
    },
  },
  {
    id: 'GIFT_REJECTED',
    get label() {
      return translate('constants:da_tu_choi');
    },
  },
  {
    id: 'GIFT_PENDING_REMOVED_ON_APP',
    get label() {
      return translate('constants:cho_go_khoi_ung_dung');
    },
  },
  {
    id: 'GIFT_REMOVED_ON_APP',
    get label() {
      return translate('constants:da_go_khoi_ung_dung');
    },
  },
  {
    id: 'LOYALTY_PENDING',
    get label() {
      return translate('constants:cho_duyet');
    },
  },
  {
    id: 'LOYALTY_APPROVED',
    get label() {
      return translate('constants:da_duyet');
    },
  },
  {
    id: 'LOYALTY_REJECTED',
    get label() {
      return translate('constants:da_tu_choi');
    },
  },
  {
    id: 'REWARD_PENDING',
    get label() {
      return translate('constants:cho_duyet');
    },
  },
  {
    id: 'REWARD_APPROVED',
    get label() {
      return translate('constants:da_duyet');
    },
  },
  {
    id: 'REWARD_REJECTED',
    get label() {
      return translate('constants:da_tu_choi');
    },
  },
  {
    id: 'EXCHANGE_REWARD_PENDING',
    get label() {
      return translate('constants:cho_duyet');
    },
  },
  {
    id: 'EXCHANGE_REWARD_APPROVED',
    get label() {
      return translate('constants:da_duyet');
    },
  },
  {
    id: 'EXCHANGE_REWARD_REJECTED',
    get label() {
      return translate('constants:da_tu_choi');
    },
  },
  {
    id: 'NOTI_SETTING_PENDING',
    get label() {
      return translate('constants:cho_duyet');
    },
  },
  {
    id: 'NOTI_SETTING_APPROVED',
    get label() {
      return translate('constants:da_duyet');
    },
  },
  {
    id: 'NOTI_SETTING_REJECTED',
    get label() {
      return translate('constants:da_tu_choi');
    },
  },
  {
    id: 'CONTENT_PENDING',
    get label() {
      return translate('constants:cho_duyet');
    },
  },
  {
    id: 'CONTENT_APPROVED',
    get label() {
      return translate('constants:da_duyet');
    },
  },
  {
    id: 'CONTENT_REJECTED',
    get label() {
      return translate('constants:da_tu_choi');
    },
  },
  {
    id: 'CONTENT_REMOVED_ON_APP',
    get label() {
      return translate('constants:da_go_khoi_ung_dung');
    },
  },
  {
    id: 'CONTENT_PENDING_REMOVE_ON_APP',
    get label() {
      return translate('constants:cho_go_khoi_ung_dung');
    },
  },
  {
    id: 'CONTENT_SETTING_PENDING',
    get label() {
      return translate('constants:cho_duyet');
    },
  },
  {
    id: 'CONTENT_SETTING_APPROVED',
    get label() {
      return translate('constants:da_duyet');
    },
  },
  {
    id: 'CONTENT_SETTING_REJECTED',
    get label() {
      return translate('constants:da_tu_choi');
    },
  },
  {
    id: 'CONTENT_SETTING_REMOVED_ON_APP',
    get label() {
      return translate('constants:da_go_khoi_ung_dung');
    },
  },
  {
    id: 'CONTENT_SETTING_PENDING_REMOVE_ON_APP',
    get label() {
      return translate('constants:cho_go_khoi_ung_dung');
    },
  },
  {
    id: 'GAME_SETTING_PENDING',
    get label() {
      return translate('constants:cho_duyet');
    },
  },
  {
    id: 'GAME_SETTING_APPROVED',
    get label() {
      return translate('constants:da_duyet');
    },
  },
  {
    id: 'GAME_SETTING_REJECTED',
    get label() {
      return translate('constants:da_tu_choi');
    },
  },
  {
    id: 'GAME_SETTING_REMOVED_ON_APP',
    get label() {
      return translate('constants:da_go_khoi_ung_dung');
    },
  },
  {
    id: 'GAME_SETTING_PENDING_REMOVE_ON_APP',
    get label() {
      return translate('constants:cho_go_khoi_ung_dung');
    },
  },
  {
    id: 'NEW_TICKET',
    get label() {
      return translate('constants:tao_moi');
    },
  },
  {
    id: 'RE_OPEN_TICKET',
    get label() {
      return translate('constants:mo_lai');
    },
  },
  {
    id: 'NEW_TICKET_MESSAGE',
    get label() {
      return translate('constants:thong_bao_moi_tu_user');
    },
  },
  {
    id: 'CANCELED_TICKET',
    get label() {
      return translate('constants:huy');
    },
  },
  {
    id: 'PENDING_TICKET',
    get label() {
      return translate('constants:dang_xu_ly');
    },
  },
  {
    id: 'WAITING_FOR_RESPONSE',
    get label() {
      return translate('constants:cho_khach_hang_phan_hoi');
    },
  },
  {
    id: 'COMPLETED',
    get label() {
      return translate('constants:hoan_thanh');
    },
  },
  {
    id: 'NOTI_GIFT_PENDING',
    get label() {
      return translate('constants:cho_duyet');
    },
  },
  {
    id: 'NOTI_GIFT_APPROVED',
    get label() {
      return translate('constants:da_duyet');
    },
  },
  {
    id: 'NOTI_GIFT_REJECTED',
    get label() {
      return translate('constants:tu_choi');
    },
  },
];
const NOTIFICATION_TYPE_ENDPOINT = [
  {
    id: 'GIFT',
    value: '/gift/',
  },
  {
    id: 'LOYALTY',
    value: '/loyalty/',
  },
  {
    id: 'REWARD',
    value: '/reward/',
  },
  {
    id: 'EXCHANGE_REWARD',
    value: '/exchange-fee/',
  },
  {
    id: 'GAME_SETTING',
    value: '/game-setting/',
  },
  {
    id: 'TICKET',
    value: '/list-tickets/',
  },
  {
    id: 'CONTENT',
    value: '/content/',
  },
  {
    id: 'NOTI_SETTING',
    value: '/notification/',
  },
  {
    id: 'CONTENT_SETTING',
    value: '/content-setting/',
  },
  {
    id: 'NOTI_GIFT',
    value: '/gift-notification/',
  },
  {
    id: 'TICKET',
    value: '/list-tickets/',
  },
];

const REDIRECT_PATHS = {
  GIFT: 'gift',
  CONTENT: 'content',
  CONTENT_SETTING: 'content-setting',
  TICKET: 'list-tickets',
};

const AUDIT_LOG_TYPE = {
  GIFT: 'GIFT',
  CONTENT: 'CONTENT',
  CONTENT_SETTING: 'CONTENT_SETTING',
  NOTI_SETTING: 'NOTIFICATION_SETTING',
  TICKET: 'TICKET',
};

const MERCHANT_PORTAL_DASHBOARD_TYPE = {
  MERCHANT_PORTAL_USER_INFO_DASHBOARD: 'MERCHANT_PORTAL_EXPORT_USER_INFO_DASHBOARD',
  MERCHANT_PORTAL_USER_INFO_RAW: 'MERCHANT_PORTAL_EXPORT_USER_INFO_RAW',
  MERCHANT_PORTAL_RETAIL_TRANSACTION_DASHBOARD:
    'MERCHANT_PORTAL_EXPORT_RETAIL_TRANSACTION_DASHBOARD',
  MERCHANT_PORTAL_RETAIL_TRANSACTION_RAW: 'MERCHANT_PORTAL_EXPORT_RETAIL_TRANSACTION_RAW',
  STORE_REWARD_TRANSACTION_DASHBOARD: 'STORE_REWARD_TRANSACTION_DASHBOARD',
  MERCHANT_PORTAL_REWARD_TRANSACTION_DASHBOARD:
    'MERCHANT_PORTAL_EXPORT_REWARD_TRANSACTION_DASHBOARD',
  MERCHANT_PORTAL_REWARD_TRANSACTION_RAW: 'MERCHANT_PORTAL_EXPORT_REWARD_TRANSACTION_RAW',
  MERCHANT_PORTAL_RELATION_RATE_DASHBOARD: 'MERCHANT_PORTAL_EXPORT_RELATION_RATE_DASHBOARD',
};

const MONTH_OPTIONS = [
  {
    get label() {
      return translate('constants:thang_1');
    },
    value: '01',
  },
  {
    get label() {
      return translate('constants:thang_2');
    },
    value: '02',
  },
  {
    get label() {
      return translate('constants:thang_3');
    },
    value: '03',
  },
  {
    get label() {
      return translate('constants:thang_4');
    },
    value: '04',
  },
  {
    get label() {
      return translate('constants:thang_5');
    },
    value: '05',
  },
  {
    get label() {
      return translate('constants:thang_6');
    },
    value: '06',
  },
  {
    get label() {
      return translate('constants:thang_7');
    },
    value: '07',
  },
  {
    get label() {
      return translate('constants:thang_8');
    },
    value: '08',
  },
  {
    get label() {
      return translate('constants:thang_9');
    },
    value: '09',
  },
  {
    get label() {
      return translate('constants:thang_10');
    },
    value: '10',
  },
  {
    get label() {
      return translate('constants:thang_11');
    },
    value: '11',
  },
  {
    get label() {
      return translate('constants:thang_12');
    },
    value: '12',
  },
];

const GIFT_TIME_OPTION_VALUE = {
  START_REDEEM_BY_SPECIFIC_DATETIME: 0,
  END_REDEEM_BY_SPECIFIC_DATETIME: 0,

  START_USAGE_BY_SPECIFIC_DATETIME: 0,
  START_USAGE_BY_SPECIFIC_EVENT: 1,
  START_USAGE_EVENT_BY_RECEIVED_DAY: 0,

  END_USAGE_BY_SPECIFIC_DATETIME: 0,
  END_USAGE_BY_DURATION: 1,
  END_USAGE_BY_TIMELINE: 2,
  END_USAGE_DURATION_BY_DATE: 'DATE',
  END_USAGE_DURATION_BY_WEEK: 'WEEK',
  END_USAGE_DURATION_BY_MONTH: 'MONTH',
  END_USAGE_DURATION_BY_YEAR: 'YEAR',
};

const GIFT_TIME_START_REDEEM_OPTIONS = [
  {
    get label() {
      return translate('constants:thoi_gian_cu_the');
    },
    value: GIFT_TIME_OPTION_VALUE.START_REDEEM_BY_SPECIFIC_DATETIME,
  },
];

const GIFT_TIME_END_REDEEM_OPTIONS = [
  {
    get label() {
      return translate('constants:thoi_gian_cu_the');
    },
    value: GIFT_TIME_OPTION_VALUE.END_REDEEM_BY_SPECIFIC_DATETIME,
  },
];

const GIFT_TIME_START_USAGE_OPTIONS = [
  {
    get label() {
      return translate('constants:thoi_gian_cu_the');
    },
    value: GIFT_TIME_OPTION_VALUE.START_USAGE_BY_SPECIFIC_DATETIME,
  },
  {
    get label() {
      return translate('constants:su_kien_cu_the');
    },
    value: GIFT_TIME_OPTION_VALUE.START_USAGE_BY_SPECIFIC_EVENT,
  },
];

const GIFT_TIME_START_USAGE_BY_SPECIFIC_EVENT_OPTIONS = [
  {
    get label() {
      return translate('constants:ngay_nhan_voucher');
    },
    value: GIFT_TIME_OPTION_VALUE.START_USAGE_EVENT_BY_RECEIVED_DAY,
  },
];

const GIFT_TIME_END_USAGE_OPTIONS = [
  {
    get label() {
      return translate('constants:thoi_gian_cu_the');
    },
    value: GIFT_TIME_OPTION_VALUE.END_USAGE_BY_SPECIFIC_DATETIME,
  },
  {
    get label() {
      return translate('constants:khoang_thoi_gian');
    },
    value: GIFT_TIME_OPTION_VALUE.END_USAGE_BY_DURATION,
  },
  {
    get label() {
      return translate('constants:moc_thoi_gian');
    },
    value: GIFT_TIME_OPTION_VALUE.END_USAGE_BY_TIMELINE,
  },
];

const GIFT_TIME_END_USAGE_BY_DURATION_OPTIONS = [
  {
    get label() {
      return translate('constants:ngay');
    },
    value: GIFT_TIME_OPTION_VALUE.END_USAGE_DURATION_BY_DATE,
  },
  {
    get label() {
      return translate('constants:tuan');
    },
    value: GIFT_TIME_OPTION_VALUE.END_USAGE_DURATION_BY_WEEK,
  },
  {
    get label() {
      return translate('constants:thang');
    },
    value: GIFT_TIME_OPTION_VALUE.END_USAGE_DURATION_BY_MONTH,
  },
  {
    get label() {
      return translate('constants:nam');
    },
    value: GIFT_TIME_OPTION_VALUE.END_USAGE_DURATION_BY_YEAR,
  },
];

const GIFT_TIME_END_USAGE_BY_TIMELINE_OPTIONS = [
  {
    get label() {
      return translate('constants:cuoi_ngay_nhan');
    },
    value: GIFT_TIME_OPTION_VALUE.END_USAGE_DURATION_BY_DATE,
  },
  {
    get label() {
      return translate('constants:cuoi_tuan_nhan');
    },
    value: GIFT_TIME_OPTION_VALUE.END_USAGE_DURATION_BY_WEEK,
  },
  {
    get label() {
      return translate('constants:cuoi_thang_nhan');
    },
    value: GIFT_TIME_OPTION_VALUE.END_USAGE_DURATION_BY_MONTH,
  },
  {
    get label() {
      return translate('constants:cuoi_nam_nhan');
    },
    value: GIFT_TIME_OPTION_VALUE.END_USAGE_DURATION_BY_YEAR,
  },
];

const RETENTION_RATE_RANGE_OPTIONS = [
  {
    get label() {
      return translate('constants:trong_vong_7_ngay');
    },
    value: 'return_7',
  },
  {
    get label() {
      return translate('constants:trong_vong_14_ngay');
    },
    value: 'return_14',
  },
  {
    get label() {
      return translate('constants:trong_vong_30_ngay');
    },
    value: 'return_30',
  },
  {
    get label() {
      return translate('constants:trong_vong_60_ngay');
    },
    value: 'return_60',
  },
  {
    get label() {
      return translate('constants:trong_vong_90_ngay');
    },
    value: 'return_90',
  },
];

const ENDPOINT_EXPORT_REPORT = {
  RETENTION_RATE: '/api/dashboard/Export/retention-rate/export',
  THONG_TIN_THANH_VIEN: '/api/dashboard/Export/thongtinthanhvien/export',
  MUA_HANG_TICH_DIEM: '/api/dashboard/Export/muahangtichdiem/export',
  TICH_VA_SU_DUNG_DIEM: '/api/dashboard/Export/tichvasudungdiem/export',
  DOI_VA_SU_DUNG_QUA: '/api/dashboard/Export/doivasudungqua/export',
};

const API_KEY_EXPORT_REPORT = 'e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855';

const ERROR_CODE_EXPORT_REPORT = {
  NO_DATA: 'no_data',
  ROW_LIMIT_EXCEEDED: 'row_limit_exceeded',
};

const CONTENT_ATTACH_REFERENCES_TYPE = {
  GIFT: 1,
  GAME: 2,
};

const CUSTOMER_FILTER_ADD_TYPE_VALUES = {
  CRITERIA: false,
  MANUAL: true,
};

const CUSTOMER_FILTER_ADD_TYPE_OPTIONS = [
  {
    get label() {
      return translate('constants:theo_tieu_chi');
    },
    value: CUSTOMER_FILTER_ADD_TYPE_VALUES.CRITERIA,
  },
  {
    get label() {
      return translate('constants:thu_cong');
    },
    value: CUSTOMER_FILTER_ADD_TYPE_VALUES.MANUAL,
  },
];

const GENDER_OPTIONS = [
  {label: 'Nam', value: 'M'},
  {
    get label() {
      return translate('constants:nu');
    },
    value: 'F',
  },
  {
    get label() {
      return translate('constants:khac');
    },
    value: 'O',
  },
];

const BIRTH_MONTH_OPTIONS = [
  {
    get label() {
      return translate('constants:thang_1');
    },
    value: 1,
  },
  {
    get label() {
      return translate('constants:thang_2');
    },
    value: 2,
  },
  {
    get label() {
      return translate('constants:thang_3');
    },
    value: 3,
  },
  {
    get label() {
      return translate('constants:thang_4');
    },
    value: 4,
  },
  {
    get label() {
      return translate('constants:thang_5');
    },
    value: 5,
  },
  {
    get label() {
      return translate('constants:thang_6');
    },
    value: 6,
  },
  {
    get label() {
      return translate('constants:thang_7');
    },
    value: 7,
  },
  {
    get label() {
      return translate('constants:thang_8');
    },
    value: 8,
  },
  {
    get label() {
      return translate('constants:thang_9');
    },
    value: 9,
  },
  {
    get label() {
      return translate('constants:thang_10');
    },
    value: 10,
  },
  {
    get label() {
      return translate('constants:thang_11');
    },
    value: 11,
  },
  {
    get label() {
      return translate('constants:thang_12');
    },
    value: 12,
  },
];

const YES_NO_OPTIONS = [
  {
    get label() {
      return translate('constants:co');
    },
    value: true,
  },
  {
    get label() {
      return translate('constants:khong');
    },
    value: false,
  },
];

const NOTIFICATION_CHANNELS = {
  SMS: 'SMS',
  ZNS: 'ZNS',
  DPOINT_APP: 'DPOINT_APP',
};

const NOTIFICATION_CHANNEL_OPTIONS = [
  {
    label: 'SMS',
    value: NOTIFICATION_CHANNELS.SMS,
  },
  {
    label: 'ZNS',
    value: NOTIFICATION_CHANNELS.ZNS,
  },
  {
    label: 'App DPoint',
    value: NOTIFICATION_CHANNELS.DPOINT_APP,
  },
];
const ATTACHMENT_TYPE_OPTIONS = [
  {
    get label() {
      return translate('constants:qua_tang');
    },
    value: 1,
  },
  {
    get label() {
      return translate('constants:tro_choi');
    },
    value: 2,
  },
  {
    get label() {
      return translate('constants:nhiem_vu');
    },
    value: 3,
  },
  {
    get label() {
      return translate('constants:noi_dung');
    },
    value: 4,
  },
];

const CONTENT_TEMPLATE_POSITION_CTA = {
  DPOINT_APP: 0,
  WEB: 1,
};

const POSITION_CTA_OPTIONS = [
  {
    get label() {
      return translate('constants:den_vi_tri_cu_the_tren');
    },
    value: CONTENT_TEMPLATE_POSITION_CTA.DPOINT_APP,
  },
  {
    get label() {
      return translate('constants:den_trang_web');
    },
    value: CONTENT_TEMPLATE_POSITION_CTA.WEB,
  },
];

const AUTOMATIC_INTERACTION_STATUS_OPTIONS = [
  {
    get label() {
      return translate('constants:ban_nhap');
    },
    value: AutomaticInteractionStatus.DRAFT,
  },
  {
    get label() {
      return translate('constants:cho_duyet');
    },
    value: AutomaticInteractionStatus.PENDING,
  },
  {
    get label() {
      return translate('constants:dang_duyet');
    },
    value: AutomaticInteractionStatus.WAITING_FOR_APPROVAL,
  },
  {
    get label() {
      return translate('constants:da_duyet');
    },
    value: AutomaticInteractionStatus.APPROVED,
  },
  {
    get label() {
      return translate('constants:tu_choi');
    },
    value: AutomaticInteractionStatus.REJECTED,
  },
  {
    get label() {
      return translate('constants:da_xoa');
    },
    value: AutomaticInteractionStatus.DELETED,
  },
];

const AUTOMATIC_INTERACTION_VALIDITY_PERIOD = {
  LIMITED: 0,
  FOREVER: 1,
};

const AUTOMATIC_INTERACTION_VALIDITY_PERIOD_OPTIONS = [
  {
    get label() {
      return translate('constants:co_thoi_han');
    },
    value: AUTOMATIC_INTERACTION_VALIDITY_PERIOD.LIMITED,
  },
  {
    get label() {
      return translate('constants:vinh_vien');
    },
    value: AUTOMATIC_INTERACTION_VALIDITY_PERIOD.FOREVER,
  },
];

const AUTO_INTERACTION_MAX_PER_USER_PERIOD_TYPE = [
  {
    get label() {
      return translate('constants:ngay');
    },
    value: 'DAY',
  },
  {
    get label() {
      return translate('constants:thang');
    },
    value: 'MONTH',
  },
  {
    get label() {
      return translate('constants:nam');
    },
    value: 'YEAR',
  },
  {
    get label() {
      return translate('constants:toan_bo_thoi_gian_hieu_luc');
    },
    value: 'VALIDITY_PERIOD',
  },
];

const TIME_TYPE_1 = {
  MILLISECOND: 'Millisecond',
  SECOND: 'Second',
  MINUTE: 'Minute',
  HOUR: 'Hour',
  DAY: 'Day',
  MONTH: 'Month',
  YEAR: 'Year',
};

const AUTO_INTERACTION_ACTIVITY_PERIOD_TYPE = [
  {
    get label() {
      return translate('constants:gio');
    },
    value: TIME_TYPE_1.HOUR,
  },
  {
    get label() {
      return translate('constants:ngay');
    },
    value: TIME_TYPE_1.DAY,
  },
  {
    get label() {
      return translate('constants:thang');
    },
    value: TIME_TYPE_1.MONTH,
  },
  {
    get label() {
      return translate('constants:nam');
    },
    value: TIME_TYPE_1.YEAR,
  },
];

const ACTIVITY_TYPE = {
  ACTIVE: 'ACTIVE',
  REMIND: 'REMIND',
};

const AUTO_INTERACTION_SENDING_TIME_TYPE = {
  SEND_RIGHT_AFTER_EVENT: {
    get label() {
      return translate('constants:gui_ngay_khi_hoat_dong_dien');
    },
    value: 0,
  },
  SEND_AFTER_EVENT: {
    get label() {
      return translate('constants:sau_khi_hoat_dong_dien_ra');
    },
    value: 1,
  },
  SEND_DAY_OF_WEEK: {
    get label() {
      return translate('constants:thu_cu_the_trong_tuan');
    },
    value: 2,
  },
  SEND_DAY_OF_MONTH: {
    get label() {
      return translate('constants:ngay_cu_the_trong_thang');
    },
    value: 3,
  },
  SEND_DAY_OF_YEAR: {
    get label() {
      return translate('constants:ngay_cu_the_trong_nam');
    },
    value: 4,
  },
};

const AUTO_INTERACTION_SENDING_TIME_PERIOD_TYPE = [
  {
    get label() {
      return translate('constants:phut');
    },
    value: TIME_TYPE_1.MINUTE,
  },
  {
    get label() {
      return translate('constants:gio');
    },
    value: TIME_TYPE_1.HOUR,
  },
  {
    get label() {
      return translate('constants:ngay');
    },
    value: TIME_TYPE_1.DAY,
  },
  {
    get label() {
      return translate('constants:thang');
    },
    value: TIME_TYPE_1.MONTH,
  },
  {
    get label() {
      return translate('constants:nam');
    },
    value: TIME_TYPE_1.YEAR,
  },
];

const DAY_OF_WEEK_OPTIONS = [
  {
    get label() {
      return translate('constants:thu_hai');
    },
    value: 1,
    order: 1,
  },
  {
    get label() {
      return translate('constants:thu_ba');
    },
    value: 2,
    order: 2,
  },
  {
    get label() {
      return translate('constants:thu_tu');
    },
    value: 3,
    order: 3,
  },
  {
    get label() {
      return translate('constants:thu_nam');
    },
    value: 4,
    order: 4,
  },
  {
    get label() {
      return translate('constants:thu_sau');
    },
    value: 5,
    order: 5,
  },
  {
    get label() {
      return translate('constants:thu_bay');
    },
    value: 6,
    order: 6,
  },
  {
    get label() {
      return translate('constants:chu_nhat');
    },
    value: 0,
    order: 7,
  },
];

const DAY_OF_MONTH_OPTIONS = [
  {
    get label() {
      return translate('constants:ngay_1');
    },
    value: 1,
  },
  {
    get label() {
      return translate('constants:ngay_2');
    },
    value: 2,
  },
  {
    get label() {
      return translate('constants:ngay_3');
    },
    value: 3,
  },
  {
    get label() {
      return translate('constants:ngay_4');
    },
    value: 4,
  },
  {
    get label() {
      return translate('constants:ngay_5');
    },
    value: 5,
  },
  {
    get label() {
      return translate('constants:ngay_6');
    },
    value: 6,
  },
  {
    get label() {
      return translate('constants:ngay_7');
    },
    value: 7,
  },
  {
    get label() {
      return translate('constants:ngay_8');
    },
    value: 8,
  },
  {
    get label() {
      return translate('constants:ngay_9');
    },
    value: 9,
  },
  {
    get label() {
      return translate('constants:ngay_10');
    },
    value: 10,
  },
  {
    get label() {
      return translate('constants:ngay_11');
    },
    value: 11,
  },
  {
    get label() {
      return translate('constants:ngay_12');
    },
    value: 12,
  },
  {
    get label() {
      return translate('constants:ngay_13');
    },
    value: 13,
  },
  {
    get label() {
      return translate('constants:ngay_14');
    },
    value: 14,
  },
  {
    get label() {
      return translate('constants:ngay_15');
    },
    value: 15,
  },
  {
    get label() {
      return translate('constants:ngay_16');
    },
    value: 16,
  },
  {
    get label() {
      return translate('constants:ngay_17');
    },
    value: 17,
  },
  {
    get label() {
      return translate('constants:ngay_18');
    },
    value: 18,
  },
  {
    get label() {
      return translate('constants:ngay_19');
    },
    value: 19,
  },
  {
    get label() {
      return translate('constants:ngay_20');
    },
    value: 20,
  },
  {
    get label() {
      return translate('constants:ngay_21');
    },
    value: 21,
  },
  {
    get label() {
      return translate('constants:ngay_22');
    },
    value: 22,
  },
  {
    get label() {
      return translate('constants:ngay_23');
    },
    value: 23,
  },
  {
    get label() {
      return translate('constants:ngay_24');
    },
    value: 24,
  },
  {
    get label() {
      return translate('constants:ngay_25');
    },
    value: 25,
  },
  {
    get label() {
      return translate('constants:ngay_26');
    },
    value: 26,
  },
  {
    get label() {
      return translate('constants:ngay_27');
    },
    value: 27,
  },
  {
    get label() {
      return translate('constants:ngay_28');
    },
    value: 28,
  },
  {
    get label() {
      return translate('constants:ngay_29');
    },
    value: 29,
  },
  {
    get label() {
      return translate('constants:ngay_30');
    },
    value: 30,
  },
  {
    get label() {
      return translate('constants:ngay_31');
    },
    value: 31,
  },
];

const INTERACTION_MAX_LENGTH = {
  MAX_LENGTH_TEMPLATE_NAME: 128,
  MAX_LENGTH_DPOINT_APP_TITLE: 50,
  MAX_LENGTH_DPOINT_APP_DESC_TABLE: 15,
  MAX_LENGTH_DPOINT_APP_1_CTA_NAME: 30,
  MAX_LENGTH_DPOINT_APP_2_CTA_NAME: 15,
};

const INTERACTION_REGEX = {
  PARAM_REGEX: /\[\[(.*?)\]\]/g,
  PATTERN: /\[{2}([A-z]|\])*$/,
};

const INTERACTION_VIEW_TYPE = {
  READ: 'READ',
  CREATE: 'CREATE',
  UPDATE: 'UPDATE',
};

const INTERACTION_CONTENT_SOURCE = {
  TEMPLATE: 0,
  CUSTOM: 1,
};

const NUMBER_OF_CTA_BUTTON_OPTIONS = [
  {
    get label() {
      return translate('constants:1_nut');
    },
    value: true,
  },
  {
    get label() {
      return translate('constants:2_nut');
    },
    value: false,
  },
];

const APPLICABLE_MERCHANT_OPTIONS = [
  {
    get label() {
      return translate('constants:tat_ca_doanh_nghiep');
    },
    value: true,
  },
  {
    get label() {
      return translate('constants:doanh_nghiep_cu_the');
    },
    value: false,
  },
];

const AUTO_INTERACTION_TABS = {
  OBJECT_SETTING_TAB: 'OBJECT_SETTING_TAB',
  ACTIVITY_TAB: 'ACTIVITY_TAB',
  SENDING_TIME_TAB: 'SENDING_TIME_TAB',
  CHANNEL_CONTENT_TAB: 'CHANNEL_CONTENT_TAB',
};

const INTERACTION_SEND_CHANNEL_OPTIONS = [
  {
    get label() {
      return translate('constants:gui_tat_ca_cac_kenh');
    },
    value: true,
  },
  {
    get label() {
      return translate('constants:gui_theo_do_uu_tien_gui');
    },
    value: false,
  },
];

const INTERACTION_CONTENT_SOURCE_OPTIONS = [
  {
    get label() {
      return translate('constants:theo_mau');
    },
    value: INTERACTION_CONTENT_SOURCE.TEMPLATE,
  },
  {
    get label() {
      return translate('constants:tuy_chinh');
    },
    value: INTERACTION_CONTENT_SOURCE.CUSTOM,
  },
];

const ENTER_DEEP_LINK_OPTION = {
  get label() {
    return translate('constants:nhap_deep_link_man_hinh_chi');
  },
  value: 'ENTER_DEEP_LINK',
};

const DEEPLINK_TABNAME_DATA = {
  MERCHANT_SCREEN: 'MERCHANT_SCREEN',
  DETAIL_SCREEN: 'DETAIL_SCREEN',
  FUNCTION_SCREEN: 'FUNCTION_SCREEN',
  HOME_PAGE: 'HOME_PAGE',
};

const ACCOUNTS_SEND_MESSAGES_TAB_KEYS = {
  SMS: 'SMS',
  ZALO_OA: 'ZNS',
};

const ACCOUNTS_SEND_MESSAGES_TAB_ITEMS = [
  {
    title: 'SMS',
    id: ACCOUNTS_SEND_MESSAGES_TAB_KEYS.SMS,
  },
  {
    title: 'Zalo OA',
    id: ACCOUNTS_SEND_MESSAGES_TAB_KEYS.ZALO_OA,
  },
];

const SERVICE_PROVIDERS = {
  GapOne: 'GapOne',
  VietGuys: 'VietGuys',
};

const SERVICE_PROVIDER_OPTIONS = [
  {label: 'GapOne', value: SERVICE_PROVIDERS.GapOne},
  // {label: 'VietGuys', value: SERVICE_PROVIDERS.VietGuys},
];

const ACCOUNTS_SEND_MESSAGES_VALUE_TYPE = {
  String: 'String',
};

const EVENTTIMEOPTION = [
  {
    id: 'EVENT_DATE',
    get label() {
      return translate('constants:ngay_dien_ra_su_kien');
    },
  },
  {
    id: 'EVENT_WEEK',
    get label() {
      return translate('constants:tuan_dien_ra_su_kien');
    },
  },
  {
    id: 'EVENT_MONTH',
    get label() {
      return translate('constants:thang_dien_ra_su_kien');
    },
  },
];

const ACTIONOPTIONS = [
  {
    id: 'ACT_PURCHASE',
    get label() {
      return translate('constants:mua_hang');
    },
  },
  {
    id: 'ACT_REFERRAL_LOYALTY',
    get label() {
      return translate('constants:moi_ban_dang_ky_lp');
    },
  },
  {
    id: 'ACT_REFERRAL',
    get label() {
      return translate('constants:gioi_thieu_ban_tai_dpoint');
    },
  },
  {
    id: 'ACT_DO_MISSION',
    get label() {
      return translate('constants:lam_nhiem_vu');
    },
  },
  {
    id: 'ACT_UPDATE_PROFILE',
    get label() {
      return translate('constants:cap_nhat_thong_tin_ca_nhan');
    },
  },
  {
    id: 'ACT_REGISTER_MEMBERSHIP',
    get label() {
      return translate('constants:dang_ky_lp');
    },
  },
  {
    id: 'ACT_GENERAL',
    get label() {
      return translate('constants:trong');
    },
  },
  {
    id: 'ACT_REFERRAL_LOYALTY_AND_PURCHASE',
    get label() {
      return translate('constants:moi_ban_dang_ky_lp_va');
    },
  },
];

const MAX_PROMOTION_PER_USER_PERIOD_TYPE = [
  {
    get label() {
      return translate('constants:chuong_trinh');
    },
    value: 'PROGRAM',
  },
  {
    get label() {
      return translate('constants:nam');
    },
    value: 'YEAR',
  },
  {
    get label() {
      return translate('constants:thang');
    },
    value: 'MONTH',
  },
  {
    get label() {
      return translate('constants:tuan');
    },
    value: 'WEEK',
  },
  {
    get label() {
      return translate('constants:ngay');
    },
    value: 'DAY',
  },
];

const EARNING_RULE_PERFORMANCE_TYPE = {
  ACCUMULATED_PURCHASE_AMOUNT: 'ACCUMULATED_PURCHASE_AMOUNT',
  ACCUMULATED_REWARDS: 'ACCUMULATED_REWARDS',
  BILL_AMOUNT: 'BILL_AMOUNT',
  REFERRAL_NUMBER: 'REFERRAL_NUMBER',
  VALUE_OF_PREVIOUSLY_PURCHASED_ORDERS: 'VALUE_OF_PREVIOUSLY_PURCHASED_ORDERS',
  GIFT_FOR_NEW_ACCOUNT: 'GIFT_FOR_NEW_ACCOUNT',
  ACCUMULATED_PURCHASE_NUMBER: 'ACCUMULATED_PURCHASE_NUMBER',
  QUALIFIED_RANK: 'QUALIFIED_RANK',
};

const MAX_EARNING_RULE_PER_USER_PERIOD_TYPE = [
  {
    get label() {
      return translate('constants:ngay');
    },
    value: 'DAY',
  },
  {
    get label() {
      return translate('constants:tuan');
    },
    value: 'WEEK',
  },
  {
    get label() {
      return translate('constants:thang');
    },
    value: 'MONTH',
  },
  {
    get label() {
      return translate('constants:nam');
    },
    value: 'YEAR',
  },
  {
    get label() {
      return translate('constants:su_kien');
    },
    value: 'EVENT',
  },
];

export {
  API_ENDPOINTS_HOST,
  API_METHOD,
  STORAGE_KEY,
  MERCHANT_PERMISSIONS,
  STORE_TYPE,
  CLASSIFIED_GIFT,
  DELIVERY_TRANSACTION_PICKUP_TYPE,
  DELIVERY_TRANSACTION_SERVICE_NAME,
  MERCHANT_NAME_OF_STRONGBOW,
  PROCESSING_STATUS,
  NOTIFICATION_TYPE_ENDPOINT,
  STATUS_COLOR,
  REDIRECT_PATHS,
  AUDIT_LOG_TYPE,
  MERCHANT_PORTAL_DASHBOARD_TYPE,
  MONTH_OPTIONS,
  RETENTION_RATE_RANGE_OPTIONS,
  GIFT_TIME_OPTION_VALUE,
  GIFT_TIME_START_REDEEM_OPTIONS,
  GIFT_TIME_END_REDEEM_OPTIONS,
  GIFT_TIME_START_USAGE_OPTIONS,
  GIFT_TIME_START_USAGE_BY_SPECIFIC_EVENT_OPTIONS,
  GIFT_TIME_END_USAGE_OPTIONS,
  GIFT_TIME_END_USAGE_BY_DURATION_OPTIONS,
  GIFT_TIME_END_USAGE_BY_TIMELINE_OPTIONS,
  ENDPOINT_EXPORT_REPORT,
  API_KEY_EXPORT_REPORT,
  ERROR_CODE_EXPORT_REPORT,
  CONTENT_ATTACH_REFERENCES_TYPE,
  CUSTOMER_FILTER_ADD_TYPE_VALUES,
  CUSTOMER_FILTER_ADD_TYPE_OPTIONS,
  GENDER_OPTIONS,
  BIRTH_MONTH_OPTIONS,
  YES_NO_OPTIONS,
  NOTIFICATION_CHANNELS,
  NOTIFICATION_CHANNEL_OPTIONS,
  ATTACHMENT_TYPE_OPTIONS,
  CONTENT_TEMPLATE_POSITION_CTA,
  POSITION_CTA_OPTIONS,
  AUTOMATIC_INTERACTION_STATUS_OPTIONS,
  AUTOMATIC_INTERACTION_VALIDITY_PERIOD,
  AUTOMATIC_INTERACTION_VALIDITY_PERIOD_OPTIONS,
  AUTO_INTERACTION_MAX_PER_USER_PERIOD_TYPE,
  TIME_TYPE_1,
  AUTO_INTERACTION_ACTIVITY_PERIOD_TYPE,
  ACTIVITY_TYPE,
  AUTO_INTERACTION_SENDING_TIME_TYPE,
  AUTO_INTERACTION_SENDING_TIME_PERIOD_TYPE,
  DAY_OF_WEEK_OPTIONS,
  DAY_OF_MONTH_OPTIONS,
  INTERACTION_MAX_LENGTH,
  INTERACTION_REGEX,
  INTERACTION_VIEW_TYPE,
  INTERACTION_CONTENT_SOURCE,
  NUMBER_OF_CTA_BUTTON_OPTIONS,
  APPLICABLE_MERCHANT_OPTIONS,
  AUTO_INTERACTION_TABS,
  INTERACTION_SEND_CHANNEL_OPTIONS,
  INTERACTION_CONTENT_SOURCE_OPTIONS,
  ENTER_DEEP_LINK_OPTION,
  DEEPLINK_TABNAME_DATA,
  ACCOUNTS_SEND_MESSAGES_TAB_KEYS,
  ACCOUNTS_SEND_MESSAGES_TAB_ITEMS,
  SERVICE_PROVIDERS,
  SERVICE_PROVIDER_OPTIONS,
  ACCOUNTS_SEND_MESSAGES_VALUE_TYPE,
  EVENTTIMEOPTION,
  ACTIONOPTIONS,
  MAX_PROMOTION_PER_USER_PERIOD_TYPE,
  EARNING_RULE_PERFORMANCE_TYPE,
  MAX_EARNING_RULE_PER_USER_PERIOD_TYPE,
};
